var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82426 4.77535C9.05858 5.00966 9.05858 5.38956 8.82426 5.62387L5.04853 9.39961H16.4C16.7314 9.39961 17 9.66824 17 9.99961C17 10.331 16.7314 10.5996 16.4 10.5996H5.04853L8.82426 14.3753C9.05858 14.6097 9.05858 14.9896 8.82426 15.2239C8.58995 15.4582 8.21005 15.4582 7.97574 15.2239L3.17574 10.4239C2.94142 10.1896 2.94142 9.80966 3.17574 9.57535L7.97574 4.77535C8.21005 4.54103 8.58995 4.54103 8.82426 4.77535Z",
    fill: "#180D01"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowLeft.fcc31de5.svg";
export { ForwardRef as ReactComponent };